module.exports = __webpack_public_path__ + "img/frame (20).c258df4c.jpg";